import download from 'downloadjs';

import Http from '../../../http';

import {
  SET_REPORT_DEFINITIONS,
  SET_REPORT_DEFINITIONS_ERROR,
  SET_METRICS_DEFINITIONS,
  SET_REPORT_DEFINITION,
  DELETE_REPORT_DEFINITION,
  SET_REPORT_DATA,
  RESET_REPORT_DATA,
  INIT_FILTER,
  UPDATE_FILTER,
  FILTER_SELECT_ALL,
  FILTER_DESELECT_ALL,
  SET_FILTERS_DIRTY,
} from './constants';

import { transformReportData } from './components/CustomReport/utils';
import { getDownloadFileName } from './utils';

const setReportDefinitions = items => ({
  type: SET_REPORT_DEFINITIONS,
  payload: items,
});

const setReportDefinitionsError = () => ({
  type: SET_REPORT_DEFINITIONS_ERROR,
});

const setMetricsDefinitions = items => ({
  type: SET_METRICS_DEFINITIONS,
  payload: items,
});

const setReportDefinition = item => ({
  type: SET_REPORT_DEFINITION,
  payload: item,
});

const deleteReportDefinition = id => ({
  type: DELETE_REPORT_DEFINITION,
  payload: id,
});

export const initFilter = (filterType, filterData) => ({
  type: INIT_FILTER,
  filterType,
  payload: filterData,
});

export const updateFilter = (filterType, filterItem) => ({
  type: UPDATE_FILTER,
  filterType,
  payload: filterItem,
});

export const filterSelectAll = filterType => ({
  type: FILTER_SELECT_ALL,
  filterType,
});

export const filterDeselectAll = filterType => ({
  type: FILTER_DESELECT_ALL,
  filterType,
});

export const setFiltersDirty = () => ({
  type: SET_FILTERS_DIRTY,
});

const setReportData = data => ({
  type: SET_REPORT_DATA,
  payload: data,
});

export const resetReportData = () => ({
  type: RESET_REPORT_DATA,
});

export const fetchReportDefinitions = brandId => dispatch => (
  Http.get(`/reports/custom?brandId=${brandId}`, null, false)
    .then(data => dispatch(setReportDefinitions(data)))
    .catch((error) => {
      if (error.status === 403) {
        dispatch(setReportDefinitionsError());
      }
    })
);

export const fetchReportDefinition = reportId => dispatch => (
  Http.get(`/reports/custom/${reportId}`)
    .then(data => dispatch(setReportDefinition(data)))
);

export const fetchMetricsDefinitions = () => dispatch => (
  Http.get('/reports/custom/metrics')
    .then(data => dispatch(setMetricsDefinitions(data)))

);

export const addCustomReport = newReport => dispatch => (
  Http.post('/reports/custom', newReport)
    .then((data) => {
      dispatch(setReportDefinition(data));
      return data;
    })
);

export const updateCustomReport = (reportId, update) => dispatch => (
  Http.put(`/reports/custom/${reportId}`, update)
    .then((data) => {
      dispatch(setReportDefinition(data));
      return data;
    })
);

export const deleteCustomReport = reportId => dispatch => (
  Http.delete(`/reports/custom/${reportId}`)
    .then(() => dispatch(deleteReportDefinition(reportId)))
);

export const fetchReportData = (reportId, criteria, filteredItems) => dispatch => (
  Http.post(`/reports/custom/${reportId}/json`, criteria)
    .then((data) => {
      const transformedData = transformReportData(data, filteredItems);
      dispatch(setReportData(transformedData));
      return transformedData;
    })
);

export const downloadCsv = (reportId, criteria) => (
  Http.postWithRawResponse(
    `/reports/custom/${reportId}/csv`,
    criteria,
    { returnHeaders: true }
  )
    .then(response =>
      download(
        response.data,
        getDownloadFileName(response.headers, 'report.csv'),
        'text/csv'
      )
    )
);

export const downloadPdf = (reportId, criteria) => (
  Http.postWithRawResponse(
    `/reports/custom/${reportId}/pdf`,
    criteria,
    { returnHeaders: true }
  )
    .then(response =>
      download(
        response.data,
        getDownloadFileName(response.headers, 'report.pdf'),
        'application/pdf'
      )
    )
);
